var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import "./FakePlayer.scss";
var FakePlayer = function (_a) {
    var children = _a.children;
    return (_jsx("div", __assign({ "data-testid": "fake-player", className: "fake-player" }, { children: _jsx("div", __assign({ className: "fake-player__content" }, { children: _jsx(_Fragment, { children: children }) })) })));
};
export default FakePlayer;
